import L from "leaflet";
export default class AddressMarker extends L.Marker {
    constructor(latLng, options) {
        super(latLng, options);
    }
}
